import { defineStyle } from '@chakra-ui/react';

const theme = defineStyle({
  
 

  // Form
  fieldGroup: { mb: '24px' },
  fieldLabel: { fontSize: '14px', fontWeight: 400, color: '#333333', mb: '8px' },
  textInput: {
    width: '100%',
    height: '52px',
    px: '16px',
    mb:6,
    border: '1px solid',
    borderColor: '#B0B0B0',
    borderRadius: '4px',
    fontSize: '14px',
    color: 'text.dark',
    backgroundColor: 'white',
    _focus: { outline: 'none', borderColor: 'secondary.800' },
    _placeholder: { color: '#727272' },
  },
  textInputError: {
    borderColor: '#F97066',
    _focus: { outline: 'none', borderColor: '#F97066' },
  },
  errorText: {
    fontSize: '12px',
    color: '#B42318',
    mt: '4px',
  },
  checkboxBorderError: {
    borderColor: '#F97066',
  },

  // File upload
  filePreview: {
    alignItems: 'center',
    gap: '12px',
    border: '1px solid',
    borderColor: 'gray.200',
    borderRadius: '4px',
    p: '12px 16px',
    mb: '8px',
  },
  fileIcon: { fontSize: '20px', flexShrink: 0 },
  fileInfo: { flex: 1, minW: 0 },
  fileName: { fontSize: '14px', color: 'gray.800' },
  fileSize: { fontSize: '12px', color: 'gray.500' },
  fileRemove: {
    color: 'gray.400',
    cursor: 'pointer',
    fontSize: '14px',
    background: 'none',
    border: 'none',
    flexShrink: 0,
    _hover: { color: 'gray.700' },
  },
  uploadAnother: {
    fontSize: '14px',
    color: 'text.cyan',
    cursor: 'pointer',
    _hover: { color: 'text.cyanHover' },
  },
  
 
});

export default theme;
